/*
  Охранник маршрута: раздел открыт только тем, у кого есть нужное разрешение.

  Меню уже прячет закрытые пункты, но адрес можно набрать руками или открыть из закладки.
  Без охранника оператор по `/import` видел экран, и каждый его запрос кончался отказом
  (аудит 28.10.2026, раздел 5.3). Теперь такой адрес ведёт на стартовую страницу роли.
  Право на сами действия по-прежнему проверяет сервер: охранник решает только, показывать
  ли экран.
*/

import { Navigate } from 'react-router-dom'

import { allows } from './sections.js'

export default function RouteGate({ profile, need, start, children }) {
  if (!allows(profile, need)) return <Navigate to={start} replace />
  return children
}
